export const DocumentEN = {
    "company":"Company",
    "dashboard":"Dashboard"
}